import {
  blackColor,
  successColor,
  whiteColor,
  grayColor,
  hexToRgb,
} from 'assets/jss/material-dashboard-react.js';

const dashboardStyle = (theme) => ({
  cardCategory: {
    color: grayColor[1],
    margin: '0',
    fontSize: '1rem',
    fontWeight: '400',
    marginTop: '0',
    paddingTop: '10px',
    marginBottom: '0',
  },
  cardCategoryWhite: {
    color: 'rgba(' + hexToRgb(whiteColor) + ',.62)',
    margin: '0',
    fontSize: '14px',
    marginTop: '0',
    marginBottom: '0',
  },
  cardHeaderFooter: {
    fontSize: '1.05rem',
    fontWeight: '400',
    width: '100%',
    float: 'left',
    padding: '0',
    margin: '5px 0 0 48px',
  },
  cardIcon__img: {
    width: '125px',
    height: '125px',
  },
  cardTitle: {
    color: grayColor[2],
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '700',
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: '3px',
    textDecoration: 'none',
    '& small': {
      color: grayColor[1],
      fontWeight: '400',
      lineHeight: '1',
    },
  },
  cardTitleWhite: {
    color: whiteColor,
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '300',
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: '3px',
    textDecoration: 'none',
    '& small': {
      color: grayColor[1],
      fontWeight: '400',
      lineHeight: '1',
    },
  },
  divider: {
    margin: '20px 0',
  },
  successText: {
    color: successColor[0],
  },
  stats: {
    color: grayColor[0],
    display: 'inline-flex',
    fontSize: '12px',
    lineHeight: '22px',
    '& svg': {
      top: '4px',
      width: '16px',
      height: '16px',
      position: 'relative',
      marginRight: '3px',
      marginLeft: '3px',
    },
    '& .fab,& .fas,& .far,& .fal,& .material-icons': {
      top: '4px',
      fontSize: '16px',
      position: 'relative',
      marginRight: '3px',
      marginLeft: '3px',
    },
  },
  table: {
    minxWidth: '100px',
  },
  tableHeader: {
    backgroundColor: '#000',
    color: '#fff',
  },
  tableCell: {
    textAlign: 'center',
    color: '#fff',
  },
  tableRow: {
    '&:nth-of-type(odd)': {
      backgroundColor: blackColor,
      opacity: '.6',
    },
    '&:nth-of-type(2n)': {
      backgroundColor: '#1769aa',
    },
  },
  toolbarWrapper: {
    '& .MuiToolbar-gutters': {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  search: {
    fontSize: '1.7rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1rem',
    },
  },
  upArrowCardCategory: {
    width: '16px',
    height: '16px',
  },
});

export default dashboardStyle;
